import { hsl } from 'polished';
export default {
    /** Hex: #1f1f1f */
    black: '#1f1f1f',
    /** Hex: #fff */
    white: '#fff',
    account: {
        /** Hex: #042746 */
        blue: '#042746',
        /** Hex: #043e5e */
        blueLight: '#043e5e',
        /** Hex: #013839 */
        green: '#013839',
        /** Hex: #014b53 */
        greenLight: '#014b53',
        /** Hex: #032B2C */
        baseGreen: '#032B2C',
    },
    base: {
        /** Hex: #0B2836 */
        blue: '#0B2836',
    },
    primary: {
        /** Hex: #FF6600 */
        orange: '#FF6600',
        /** Hex: #11385A */
        blue: '#11385A',
        /** Hex: #E9EDEE */
        blueGrey: '#E9EDEE',
        /** Hex: #ec671c */
        base: '#ec671c',
        text: '#ff6633',
    },
    secondary: {
        /** Hex: #F4F6F6*/
        lightGrey: '#F4F6F6',
        baseDark: '#292b2c',
        green: '#006164',
        greenBright: '#82BC00',
        blueGrey: '#C8D2D8',
        blueGreyFaded: '#889BAC',
        lightBlue: '#0096B8',
        pink: '#A72D68',
        accountCardBlue: '#DEF0FF',
        accountCardGreen: '#D1F1F5',
        lightOrange: '#FFE0CC',
        lightPink: '#F9D5E5',
    },
    banner: {
        blue: '#288DC0',
        pink: '#A60063',
        purple: '#77649F',
        green: '#005D63',
    },
    tag: {
        news: '#AA7BC9',
        event: '#25CAD3',
        report: '#EF3FA9',
        press: '#4D0991',
    },
    green: '#4F951A',
    lightGreen: '#EDEEE9',
    lightBlue: '#E9EDE9',
    validation: {
        /** Hex: #DA291C */
        invalid: '#DA291C',
        /** Hex: #DA291C */
        valid: '#008C15',
    },
    grey: {
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
